var clockInterval = null

const actions = {
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////
    initialize({ dispatch }) {
        // dispatch('startClock')
    },
    startClock({ state, commit }) {
        if (clockInterval != null) {
            clearInterval(clockInterval)
            clockInterval = null
        }
        clockInterval = setInterval(function () {
            commit('UPDATE_CURRENT_TIME')
        }, 1000)
    },
    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    }
}

export default actions
